export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    upload: 'Upload',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    back: 'Back',
    zh: 'Chinese',
    en: 'English'
  },
  document: {
    title: 'Title',
    titleEng: 'English Title',
    type: 'Type',
    author: 'Author',
    content: 'Content',
    contentEng: 'English Content',
    sortDate: 'Content Date',
    publishDate: 'Publish Date',
    attachmentSection: 'Attachments',
    thumbnail: 'Thumbnail',
    documentTypes: {
      confidentialFile: 'Confidential File',
      courtVerdict: 'Court Verdict',
      backgroundStory: 'Background Story'
    },
    form: {
      newDocument: 'New Document',
      editDocument: 'Edit Document',
      titleRequired: 'Please enter title',
      titleEngRequired: 'Please enter English title',
      typeRequired: 'Please select document type',
      contentRequired: 'Please enter content',
      contentEngRequired: 'Please enter English content',
      sortDateRequired: 'Please select content date',
      selectFile: 'Select File',
      fileTooLarge: 'File size cannot exceed 100MB',
      uploadAttachment: 'Upload Attachment',
      selectThumbnail: 'Select Thumbnail',
      thumbnailTooLarge: 'Thumbnail size cannot exceed 5MB',
      invalidImageType: 'Only JPG, PNG and GIF images are supported',
      removeThumbnail: 'Remove Thumbnail',
      thumbnailUploadSuccess: 'Thumbnail uploaded successfully',
      thumbnailUploadError: 'Failed to upload thumbnail',
      thumbnailDeleteSuccess: 'Thumbnail deleted successfully',
      thumbnailDeleteError: 'Failed to delete thumbnail'
    },
    list: {
      noDocuments: 'No documents found',
      search: 'Search documents...',
      filter: 'Filter',
      sort: 'Sort'
    },
    tabs: {
      content: 'Content',
      attachments: 'Attachments'
    },
    attachments: {
      clickToView: 'Click any attachment to view details',
      uploadedAt: 'Uploaded on',
      view: 'View Attachment',
      backToList: 'Back to List',
      unsupportedType: {
        title: 'Preview Not Available',
        message: 'Please download to view this file type'
      }
    },
    actions: {
      back: 'Back',
      backToHome: 'Back to Home'
    },
    error: {
      notFound: {
        title: 'Document Not Found',
        message: 'Sorry, the document you requested does not exist or has been deleted.'
      }
    },
    date: {
      unknown: 'Unknown Date'
    },
    types: {
      confidentialFile: 'Confidential File',
      courtVerdict: 'Court Verdict',
      backgroundStory: 'Background Story',
      unknown: 'Unknown Type'
    }
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    loginSuccess: 'Login successful',
    loginError: 'Login failed',
    logoutSuccess: 'Logged out successfully'
  },
  nav: {
    home: 'Home',
    documents: 'Documents',
    admin: 'Admin',
    settings: 'Settings'
  },
  home: {
    title: 'CCP Archives',
    subtitle: 'Preserving Historical Truth, Remembering Historical Lessons',
    description: '',
    aboutUs: {
      title: 'About Us',
      content: 'All materials in this archive are sourced from public channels or historical documents, subject to rigorous verification. We adhere to the principles of objectivity and fairness, letting historical facts speak for themselves.'
    },
    quickLinks: {
      title: 'Quick Links',
      home: 'Home',
      confidential: 'Confidential Documents',
      verdicts: 'Court Verdicts',
      stories: 'Behind the Stories',
      admin: 'Admin'
    },
    footer: {
      copyright: '© {year} CCP Archives - Preserving Historical Truth',
      closeMenu: 'Close Menu'
    },
    navigation: {
      login: 'Login',
      logout: 'Logout'
    },
    hero: {
      title: 'CCP Archives',
      subtitle: 'Preserving Historical Truth, Remembering Historical Lessons',
      classification: 'Top Secret Archives'
    },
    mission: {
      title: 'Our Mission',
      content: 'The CCP Archives is dedicated to collecting, organizing, and preserving documentary materials about the historical crimes of the Chinese Communist Party, including confidential documents, court verdicts, and the stories behind historical events. Our mission is to ensure that historical truth is not distorted or forgotten by preserving these historical records, providing future generations with opportunities to learn from history.\n\nAll materials in this archive are sourced from public channels or historical documents, subject to rigorous verification. We adhere to the principles of objectivity and fairness, letting historical facts speak for themselves.'
    },
    categories: {
      title: 'Document Categories',
      confidential: {
        title: 'Confidential Documents',
        description: 'Internal CCP confidential documents revealing its true nature and crimes. These documents demonstrate the vast difference between the CCP\'s public statements and internal decisions.',
        button: 'View Documents'
      },
      verdicts: {
        title: 'Court Verdicts',
        description: 'Court trial records and verdicts against the CCP and its officials, documenting historical crimes and evidence confirmed through judicial proceedings.',
        button: 'View Verdicts'
      },
      stories: {
        title: 'Behind the Stories',
        description: 'Revealing the truth and historical events behind CCP crimes, restoring historical truth through detailed investigation and research.',
        button: 'View Stories'
      }
    },
    quote: {
      text: 'History will not be forgotten, nor will the people. Only by remembering history can we avoid repeating its mistakes.',
      author: 'CCP Archives'
    }
  },
  confidential: {
    title: 'Confidential Documents',
    description: 'This collection contains internal CCP confidential documents that reveal its true nature and crimes',
    search: {
      placeholder: 'Search by title'
    },
    noDocuments: 'No documents found',
    document: {
      attachments: 'attachments',
      readMore: 'Read More',
      unknownDate: 'Unknown Date',
      noSummary: 'No summary available'
    }
  },
  verdicts: {
    title: 'Court Verdicts',
    description: 'This collection contains court trial records and verdicts against the CCP and its officials',
    search: {
      placeholder: 'Search by title'
    },
    noDocuments: 'No documents found',
    document: {
      attachments: 'attachments',
      readMore: 'Read More',
      unknownDate: 'Unknown Date',
      noSummary: 'No summary available'
    }
  },
  stories: {
    title: 'Behind the Stories',
    description: 'This collection reveals the truth and historical events behind CCP crimes',
    search: {
      placeholder: 'Search by title'
    },
    noDocuments: 'No documents found',
    document: {
      attachments: 'attachments',
      readMore: 'Read More',
      unknownDate: 'Unknown Date',
      noSummary: 'No summary available'
    }
  }
} 